<div class="painel-principal" style="padding: 10px;">

    <form #formCadastro="ngForm">
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlex="60%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Materiais</mat-label>
                <mat-select [(ngModel)]=materialAcao.material.id name="material" (selectionChange)="carregarDadosMaterial()">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of materiais" [value]=i.id>
                        {{i.nome}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="materiais?.length === 0" align="start">Nenhuma material cadastrado</mat-hint>
            </mat-form-field>
            
            <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                <input [(ngModel)]=materialAcao.quantidadeMaterial type="number" min=0 
                       matInput  
                       name="quantidadeMaterial" placeholder="Quantidade de materiais" />
            </mat-form-field>
        </div>
    </form>

</div>


<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="initObjeto()">
        Limpar
    </button>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary" (click)="adicionar()">
        Adicionar
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="cancelar()">
        Cancelar
    </button>

</div>